/** Largeur de contenu (sans padding) : c'est la reference des largeurs en %. */
export function contentWidth(element: HTMLElement | null): number {
  if (!element) return 0;
  const style: CSSStyleDeclaration = getComputedStyle(element);
  return element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
}
